import { cva, type VariantProps } from "class-variance-authority";

export { default as Badge } from "./Badge.vue";

export const badgeRootVariants = cva(
    "inline-flex items-center justify-center border shrink-0 w-fit font-pretendard font-normal transition-colors",
    {
        variants: {
            size: {
                large: "h-sementic-5 p-4 rounded-small1 text-body-medium",
                medium: "h-sementic-4 p-4 rounded-small1 text-body-small",
            },
            color: {
                primary: "",
                secondary: "",
                gray: "",
                point: "",
                danger: "",
                warning: "",
                success: "",
                info: "",
            },
            type: {
                outline: "",
                solid: "",
                solidPastel: "",
            },
        },
        compoundVariants: [
            /** outline */
            {
                type: "outline",
                color: "primary",
                class: "border-border-primary text-t-primary bg-surface-white",
            },
            {
                type: "outline",
                color: "secondary",
                class: "border-border-secondary text-t-secondary bg-surface-white",
            },
            {
                type: "outline",
                color: "gray",
                class: "border-border-gray-darker text-t-subtle bg-surface-white",
            },
            {
                type: "outline",
                color: "point",
                class: "border-border-secondary text-t-secondary bg-surface-white",
            },
            {
                type: "outline",
                color: "danger",
                class: "border-border-danger text-t-danger bg-surface-white",
            },
            {
                type: "outline",
                color: "warning",
                class: "border-border-warning text-t-warning bg-surface-white",
            },
            {
                type: "outline",
                color: "success",
                class: "border-border-success text-t-success bg-surface-white",
            },
            {
                type: "outline",
                color: "info",
                class: "border-border-information text-t-information bg-surface-white",
            },
            /** solid */
            {
                type: "solid",
                color: "primary",
                class: "border-border-primary text-t-inverse-static bg-element-primary",
            },
            {
                type: "solid",
                color: "secondary",
                class: "border-border-secondary text-t-inverse-static bg-element-secondary",
            },
            {
                type: "solid",
                color: "gray",
                class: "border-border-gray-darker text-t-inverse-static bg-element-gray",
            },
            {
                type: "solid",
                color: "point",
                class: "border-border-secondary text-t-inverse-static bg-element-secondary",
            },
            {
                type: "solid",
                color: "danger",
                class: "border-border-danger text-t-inverse-static bg-element-danger",
            },
            {
                type: "solid",
                color: "warning",
                class: "border-border-warning text-t-inverse-static bg-element-warning",
            },
            {
                type: "solid",
                color: "success",
                class: "border-border-success text-t-inverse-static bg-element-success",
            },
            {
                type: "solid",
                color: "info",
                class: "border-border-information text-t-inverse-static bg-element-information",
            },
            /** solid pastel */
            {
                type: "solidPastel",
                color: "primary",
                class: "border-border-primary-light text-t-primary bg-surface-primary-subtler",
            },
            {
                type: "solidPastel",
                color: "secondary",
                class: "border-border-secondary-light text-t-secondary bg-element-secondary-light",
            },
            {
                type: "solidPastel",
                color: "gray",
                class: "border-border-gray-light text-t-subtle bg-surface-gray-subtler",
            },
            {
                type: "solidPastel",
                color: "point",
                class: "border-border-secondary text-t-secondary bg-surface-secondary-subtler",
            },
            {
                type: "solidPastel",
                color: "danger",
                class: "border-element-danger-lighter text-t-danger bg-element-danger-lighter",
            },
            {
                type: "solidPastel",
                color: "warning",
                class: "border-border-warning-light text-t-warning bg-surface-warning-subtler",
            },
            {
                type: "solidPastel",
                color: "success",
                class: "border-element-success-lighter text-t-success bg-element-success-lighter",
            },
            {
                type: "solidPastel",
                color: "info",
                class: "border-element-information-lighter text-t-information bg-element-information-lighter",
            },
        ],
        defaultVariants: {
            type: "outline",
            color: "primary",
            size: "medium",
        },
    },
);

export type BadgeRootVariants = VariantProps<typeof badgeRootVariants>;
